import { registerApplication, start } from 'single-spa'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
import RecaptchaWrapper from './components/RecaptchaWrapper'

registerApplication({
  name: 'events',
  app: () => window.System.import('events'),
  activeWhen: (location) => location.pathname.startsWith('/events')
})

start()

const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('77a87ca6d6164b5487bd3bee5c84dce1').install()

root.render(
  <Provider store={configureStore()}>
    <RecaptchaWrapper>
      <App />
    </RecaptchaWrapper>
  </Provider>
)

reportWebVitals()